import { restAxios } from './httpClient';

export const getPartnerPreviewParticipations = (companyId) => {
	return restAxios.get('/software/partner-preview-participations', {
		params: { companyId }
	});
};

export const createPartnerPreviewParticipation = (payload) => {
	return restAxios.post('/software/partner-preview-participations', payload);
};

export const updatePartnerPreviewParticipation = (participationId, payload) => {
	return restAxios.patch(`/software/partner-preview-participations/${participationId}`, payload);
};

export const getPartnerPreviewNotificationRecipients = (companyId, { signal } = {}) => {
	return restAxios.get('/software/partner-preview-notification-recipients', {
		params: { companyId },
		signal
	});
};
